export const reviews = [
  {
    id: 1,
    rating: 4.4,
    imgUrl: "images/reviews/tab1.png",
    name: "Er. Pradipta Parida",
    location: "Orisha, India",
    review:
      "Hello, I am Pradipta Parida. I have completed my online Diploma in Diet and Nutrition under supervision of Dr Monideep Baruah, MD, NHWM, one of the well known nutrition specialists from Assam,India. It was awesome. I learnt so many things, we all supposed to know. We can apply this knowledge at least for ourselves and our family to be healthy. Personally I believe this important curriculum may be added in our school education. Thanks a lot.",
  },
  {
    id: 2,
    rating: 4.5,
    imgUrl: "images/reviews/tab2.png",
    name: "Ruby Sarma",
    location: "Guwahati, Assam, India",
    review:
      "I completed a 6-month Diploma Course in Diet and Nutrition under the mentorship of Dr. Monideep Baruah, MD, NHWM. It was an incredible experience, teaching me the importance of a balanced diet for a disease-free, healthy lifestyle. I’ve successfully applied this knowledge to manage my hormonal imbalance and my sister's neuro issue with the right food supplements and exercises. The coordinator’s clear, friendly communication made learning and implementation easier for both myself and my clients. Thank you, Sir, for this invaluable guidance.",
  },
  {
    id: 3,
    rating: 5,
    imgUrl: "images/reviews/tab3.png",
    name: "Narayan Bora",
    location: "Golaghat, Assam, India",
    review:
      "I have gained extensive knowledge in diet and nutrition under the guidance of Dr. Monideep Baruah, MD, NHWM. Through his teachings, I now understand the importance of nutrition and the impact of a balanced diet. Dr. Monideep Sir covered key topics such as human physiology, eating disorders, weight management, sources of nutrition, and disease causes. I have already applied these principles to help others, seeing positive results. Thank you, Dr. Monideep Sir, for your invaluable mentorship",
  },
  {
    id: 4,
    rating: 4.5,
    imgUrl: "images/reviews/tab4.png",
    name: "Er. Sachindra Boruah",
    location: "Udaipur, Rajasthan, India",
    review:
      "I am Sachindra Boruah from Udaipur, Rajasthan, and in December 2022, I completed a 6-month Diploma in 'Diet and Nutrition' under Dr. Monideep Boruah, MD, NHWM. This course taught me about human anatomy, the importance of nutrition, and how diet patterns impact lifestyle diseases. I learned how nutritional imbalances can affect health. Dr. Monideep Boruah Sir provided excellent virtual training, guiding us on how to apply this knowledge professionally. I highly recommend this course to anyone seeking to improve their lifestyle and educate others.",
  },
  {
    id: 5,
    rating: 4.5,
    imgUrl: "images/reviews/tab5.png",
    name: "Munindra Neog",
    location: "North Lakhimpur, Assam, India",
    review:
      "Hello, I am Munindra Neog, and I completed a 6-month Diploma course in 'Diet and Nutrition' under Dr. Monideep Boruah, MD, NHWM, a renowned Reviewer Scientist - European Journal of Nutrition. I learned about unhealthy diet patterns causing lifestyle diseases and the essential nutrients needed for our body. Dr. Monideep Boruah Sir explained these concepts with clarity using slides and pictures. Whenever I struggled with any topic, he would clarify it in another class. I am thankful to Dr. Monideep Boruah Sir for sharing his invaluable knowledge.",
  },
  {
    id: 6,
    rating: 5,
    imgUrl: "images/reviews/tab6.png",
    name: "Dipen Bharali",
    location: "Dhemaji, Assam, India",
    review:
      "Hi, Namaste! I am Dipen Bharali, and I completed a 6-month Diploma course in Diet and Nutrition under the supervision of Dr. Monideep Boruah, MD, NHWM, Reviewer Scientist - European Journal of Nutrition. Through this course, I learned about optimal health and lifestyle diseases. Dr. Monideep Boruah Sir explained everything with great clarity, providing invaluable knowledge. This subject is very important in my life, and I sincerely thank Dr. Monideep Boruah Sir.",
  },
  {
    id: 7,
    rating: 4,
    imgUrl: "images/reviews/tab7.png",
    name: "Lakhi Nath Boruah",
    location: "Dolohat, Assam, India",
    review:
      "I completed an 8-month Diploma in Diet and Nutrition under the esteemed guidance of Dr. Monideep Boruah, MD, NHWM. The course highlighted the vital connection between health and wealth, addressing the rising prevalence of degenerative lifestyle diseases caused by factors such as nutritional deficiencies, oxidative stress, and toxins. Dr. Boruah's exceptional instruction, complemented by engaging demonstrations and videos, made complex concepts accessible and impactful. This knowledge has equipped me with valuable tools for health management and disease prevention. I am confident this course will enable us to provide meaningful health support to future generations.",
  },
  {
    id: 8,
    rating: 4.5,
    imgUrl: "images/reviews/tab8.png",
    name: "Dhurbajyoti Hazarika",
    location: "Golaghat, Assam, India",
    review:
      "Through the Diet and Nutrition course organized by Dr. Monideep Boruah, MD, NHWM, I acquired in-depth knowledge on nutrition, supplements, human physiology, and the significance of a balanced diet. The course also focused on immunity, its enhancement, and the essential role of vitamins and minerals. Post-course, I engaged with individuals to address lifestyle diseases, offering solutions for long-term health issues. This course is crucial for everyone, fostering a healthier society. It equips us with the tools to promote overall well-being and vitality.",
  },
  {
    id: 9,
    rating: 4,
    imgUrl: "images/reviews/tab9.png",
    name: "Nipal Boruah",
    location: "Dhemaji, Assam, India",
    review:
      "I gained immense value from the Diet & Nutrition Diploma course I completed over the past four months. In today’s world, understanding Diet & Nutrition is essential for maintaining optimal health. I am deeply grateful to Dr. Monideep Boruah, MD, NHWM, for providing this invaluable opportunity to learn. This course equipped me with knowledge on food balance, supplement intake, and their benefits, enabling me to support others effectively. Thanks to Dr. Boruah’s clear and insightful teaching, I have successfully recommended supplements to my family and others, greatly improving their well-being.",
  },
  {
    id: 10,
    rating: 5,
    imgUrl: "images/reviews/tab10.png",
    name: "Er. Anirban Gupta",
    location: "Guwahati, Assam, India",
    review:
      "Hi, I am Anirban Gupta, a Mechanical Engineer, and I completed the 'Diploma in Diet and Nutrition' course on 15.12.2022 under the guidance of Dr. Monideep Boruah, MD, NHWM. I learned about the three nutrient processes in our body and the five nutrient groups—proteins, carbohydrates, lipids, vitamins, and minerals. The course covered essential topics such as organ systems, eating disorders, balanced diets, immunity, weight control, and diseases caused by nutrient deficiencies. I gained valuable insights into nutrition and its impact on health, and I'm confident in applying this knowledge to improve my life and share it with others.",
  },
  {
    id: 11,
    rating: 5,
    imgUrl: "images/reviews/tab11.png",
    name: "Jyoti Bhuyan",
    location: "North Lakhimpur, Assam, India",
    review:
      "Hello, I am Jyoti Bhuyan, and I completed a 6-month Diploma course in 'Diet and Nutrition' under the guidance of Dr. Monideep Boruah, MD, NHWM, a renowned Reviewer Scientist - European Journal of Nutrition. This course provided in-depth knowledge on the impact of poor dietary patterns on lifestyle diseases and the necessary nutrients for optimal health. Dr. Monideep Boruah Sir expertly explained complex topics with visual aids, ensuring clarity and deeper understanding. He also highlighted how we can apply this knowledge in professional settings. I am truly thankful for the invaluable insights Dr. Boruah has shared, which will significantly impact my life and work.",
  },
  {
    id: 12,
    rating: 5,
    imgUrl: "images/reviews/tab12.png",
    name: "Krishnakanta Boruah",
    location: "Laluk, Assam, India",
    review:
      "Hello, I am Krishnakanta Boruah, and I completed a 6-month Diploma course in 'Diet and Nutrition' under the esteemed guidance of Dr. Monideep Boruah, MD, NHWM, a renowned Reviewer Scientist - European Journal of Nutrition. The course deepened my understanding of how poor dietary patterns contribute to lifestyle diseases and the critical role of nutrients in mitigating these issues. Dr. Boruah Sir adeptly explained complex topics through detailed slides and visuals, ensuring clarity. He also provided practical insights into applying this knowledge to our lives. I am truly grateful to Dr. Boruah Sir for his invaluable teachings.",
  },
  {
    id: 13,
    rating: 4.5,
    imgUrl: "images/reviews/tab13.png",
    name: "Jay Gogoi",
    location: "Berlin, Germany",
    review:
      "Hi, my name is Jay Gogoi, and I highly recommend Dr. Monideep Boruah, MD, NHWM, an exceptional wellness specialist. Under his expert guidance, I have overcome various health challenges and now enjoy optimal well-being. His wellness counseling has been instrumental in maintaining a healthy lifestyle. Even after relocating to Germany for work, I recognize the vital role of his expertise. For anyone seeking comprehensive wellness support, Dr. Boruah is an outstanding choice.",
  },
  {
    id: 14,
    rating: 4.5,
    imgUrl: "images/reviews/tab14.png",
    name: "Raju Deuri",
    location: "Naharlagun, Arunachal Pradesh, India",
    review:
      "Greetings to all! I am Raju Deuri from Guwahati, Assam. I have had the privilege of attending multiple health and wellness workshops conducted by the esteemed Dr. Monideep Boruah, MD, NHWM. These sessions have been profoundly transformative, enabling me to overcome my previous health challenges and achieve a state of optimal well-being. Today, I am delighted to share that I am completely fit and healthy, all thanks to the invaluable knowledge and guidance imparted through these workshops. I wholeheartedly encourage others to participate in these life-changing sessions to enhance their health and lead a vibrant life.",
  },
  {
    id: 15,
    rating: 4,
    imgUrl: "images/reviews/tab15.png",
    name: "Dr. Tarun Gogoi",
    location: "JNU, New Delhi, India",
    review:
      "Hello, I am Tarun, a PhD scholar at Jawaharlal Nehru University. I have been receiving wellness counseling from the esteemed Dr. Monideep Boruah, MD, NHWM, whose guidance has been immensely beneficial. In 2020, I contracted COVID-19, and during the post-recovery phase, I sought Dr. Boruah’s expert advice. His holistic wellness approach and invaluable suggestions significantly accelerated my recovery, allowing me to regain my health within just five days. I highly recommend his wellness programs to anyone seeking a comprehensive path to better health and well-being.",
  },
];
